module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "map",
    attrs: {
      "id": "mapContainer"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "searchPanel"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1015acc5","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/AMapLocation.vue
// module id = 313
// module chunks = 0